import { parlorRichSearch } from "./parlor";
import { commonRichSearch } from "./common";
import { guidebookRichSearch } from "./guidebook";
import { informationPriceRichSearch } from "./information-price";
import { funeralRichSearch } from "./funeral";
import { facilitiesRichSearch } from "./facilities";
import { RecommendationParlorRichSearch } from "./recommendationParlor";

export const richSearchData = {
  common: commonRichSearch,
  parlor: parlorRichSearch,
  guidebook: guidebookRichSearch,
  informationPrice: informationPriceRichSearch,
  funeral: funeralRichSearch,
  facilities: facilitiesRichSearch,
  RecommendationParlor: RecommendationParlorRichSearch,
};
